import { render, staticRenderFns } from "./ImportedPeople.vue?vue&type=template&id=6add049c&scoped=true&"
import script from "./ImportedPeople.vue?vue&type=script&lang=js&"
export * from "./ImportedPeople.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=6add049c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add049c",
  null
  
)

export default component.exports